import React from 'react';

import { toLowerKebabCase } from '../../../utils/utils';

import './LandingPageTile.scss';
import { useSelector } from 'react-redux';
import { isCustomerWebViewEnabled } from '../../../redux/modules/authentication/authentication.module.selectors';

const LandingPageTile = ({
  description,
  icon: Icon,
  link,
  title,
  newPage = false,
  sectionTitle,
}) => {
  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);
  const disabledTile =
    customerWebViewEnabled &&
    (title === 'Trade Stocks & ETFs' ||
      title === 'Trade Mutual Funds ' ||
      title === 'Trade Options¹');
  const handleLinkClick = (event) => {
    if (disabledTile) {
      event.preventDefault();
    }
  };
  return (
    <a
      className={
        !disabledTile
          ? `landing-page-tile e2e-${toLowerKebabCase(title)}-tile`
          : `landing-page-disabled e2e-${toLowerKebabCase(title)}-tile`
      }
      href={link}
      id={`landing-page-tile-${toLowerKebabCase(title)}-link-${sectionTitle}`}
      target={newPage ? '_blank' : '_self'}
      rel="noreferrer"
      onClick={handleLinkClick}
    >
      {Icon}
      <div
        className={
          !disabledTile
            ? 'college-branded-text landing-page-tile-title'
            : 'college-branded-text landing-page-tile-disabled'
        }
      >
        {title}
      </div>
      <p className="college-branded-descriptor landing-page-tile-description">
        {description}
      </p>
    </a>
  );
};

export default LandingPageTile;
